import { render, staticRenderFns } from "./CierreLaCeiba.vue?vue&type=template&id=6b118660&"
import script from "./CierreLaCeiba.vue?vue&type=script&lang=js&"
export * from "./CierreLaCeiba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports